import { Flex, Spin, Typography } from 'antd';

const { Text } = Typography;

interface PageLoaderProps {
  tip?: string;
  size?: 'small' | 'default' | 'large';
}

/**
 * Page Loading Component
 * Displayed while lazy-loaded route components are being loaded
 * or during initial app initialization
 */
export const PageLoader: React.FC<PageLoaderProps> = ({
  tip = 'Loading...',
  size = 'large',
}) => {
  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={16}
      style={{ height: '100vh' }}
    >
      <Spin size={size} />
      <Text type="secondary">{tip}</Text>
    </Flex>
  );
};

export default PageLoader;
